import hunanVideo from '../assets/videos/hunan-video.mp4'
import ningxiaVideo from '../assets/videos/ningxia.mp4'

export const Testimonials = () => {
    const videos = [
        { src: hunanVideo, title: 'Hunan University of Chinese Medicine' },
        { src: ningxiaVideo, title: 'Ningxia Medical University' }
    ]

    return (
        <>
            <style>{`
          .testimonials-section { padding: 60px 20px; max-width: 1200px; margin: 0 auto; }
          .testimonials-title { text-align: center; font-size: clamp(1.8rem, 4vw, 2.5rem); font-weight: 700; margin-bottom: 8px; }
          .testimonials-sub { text-align: center; color: #6b7280; margin-bottom: 28px; font-size: clamp(0.95rem, 2.5vw, 1.05rem); }

          /* marquee layout */
          .marquee { overflow: hidden; position: relative; }
          .marquee-track { display: flex; align-items: stretch; gap: 20px; width: max-content; animation: marquee-move 30s linear infinite; }
          .marquee:hover .marquee-track { animation-play-state: paused; }
          @keyframes marquee-move { from { transform: translateX(0); } to { transform: translateX(-50%); } }

          .video-card { background: #ffffff; border-radius: 14px; box-shadow: 0 12px 30px rgba(0,0,0,0.08); overflow: hidden; transition: transform .25s ease, box-shadow .25s ease; border: 1px solid rgba(0,0,0,0.06); width: 360px; }
          @media (max-width: 640px) { .video-card { width: 280px; } }
          .video-card:hover { transform: translateY(-4px); box-shadow: 0 18px 40px rgba(0,0,0,0.12); }
          .video-wrapper { position: relative; background: #000; aspect-ratio: 16 / 9; }
          .video-wrapper video { width: 100%; height: 100%; object-fit: cover; display: block; }
          .video-meta { padding: 12px 14px; }
          .video-title { font-weight: 600; font-size: 0.95rem; color: #111827; }
        `}</style>

            <section className="testimonials-section">
                <h2 className="testimonials-title">Campus Life & Student Experiences</h2>
                <p className="testimonials-sub">Discover what makes each university unique. Watch real stories, explore campus environments, and hear directly from students and universities through the clips below</p>

                <div className="marquee">
                    <div className="marquee-track">
                        {[...videos, ...videos].map((vid, i) => (
                            <div className="video-card" key={i}>
                                <div className="video-wrapper">
                                    <video
                                        src={vid.src}
                                        preload="metadata"
                                        autoPlay
                                        muted
                                        playsInline
                                        onMouseEnter={(e) => { e.currentTarget.controls = true }}
                                        onMouseLeave={(e) => { e.currentTarget.controls = false }}
                                    ></video>
                                </div>
                                <div className="video-meta">
                                    <div className="video-title">{vid.title}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Testimonials